import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_OUTLET_STATUS_COUNTS, GET_OUTLET_STATUS_COUNTS_ERROR, GET_OUTLET_STATUS_COUNTS_SUCCESS } from '../../actions.js';

// The outlets endpoint only reports a total for the status it was called with, so the
// listing tabs would each only ever know their own count. Both statuses are asked for in
// parallel here - a page of one row each, since only `totalCount` is read - and the tabs
// keep showing both numbers no matter which one is open.
const OUTLET_STATUSES = ['active', 'inactive'];

function* fetchStatusCount(status, urlParams) {
  const filteredHeaders = { ...customHeaders };
  delete filteredHeaders['X-Requested-By'];

  const response = yield call(apiCall, {
    url: `${adminAPIURL}/v2/vendor/digital/outlets`,
    method: 'GET',
    headers: {
      ...filteredHeaders,
    },
    params: {
      page_size: 1,
      page_index: 1,
      ...urlParams,
      status,
    },
  });

  if (response.status !== 200) return null;

  return response?.data?.totalCount ?? null;
}

function* getOutletStatusCounts({ payload }) {
  try {
    const counts = yield all(OUTLET_STATUSES.map(status => call(fetchStatusCount, status, payload?.urlParams)));

    yield put({
      type: GET_OUTLET_STATUS_COUNTS_SUCCESS,
      payload: OUTLET_STATUSES.reduce((accumulator, status, index) => ({ ...accumulator, [status]: counts[index] }), {}),
    });
  } catch (error) {
    yield put({ type: GET_OUTLET_STATUS_COUNTS_ERROR, payload: error });
  }
}

export function* watchGetOutletStatusCounts() {
  yield takeEvery(GET_OUTLET_STATUS_COUNTS, getOutletStatusCounts);
}

function* getOutletStatusCountsSaga() {
  yield all([fork(watchGetOutletStatusCounts)]);
}

export default getOutletStatusCountsSaga;
